import {
  ICommonDict,
  IErrorDict,
  IPasswordReqDict,
  IBreakoutDict,
  IThankYouDict,
  IRegistrationDict,
  ISurveyDict,
  IScenesDict
} from 'types'

const common: ICommonDict = {
  alreadyHaveAnAccount: 'Already registered?',
  back: 'Back',
  completeRegistration: 'Complete Registration',
  confirmationCode: 'Confirmation code',
  confirmEmail: 'Confirm E-mail',
  confirmEmailInstructions:
    'A confirmation code was sent to your e-mail. Didn’t receive it? Check your spam folder or hit back and try again.',
  confirmPassword: 'Confirm Password',
  continue: 'Continue',
  dontHaveAnAccount: "Haven't registered yet?",
  email: 'E-mail',
  eventInfo: 'Event Info',
  firstName: 'First Name',
  forgotPassword: 'Forgot Password?',
  help: 'Help',
  lastName: 'Last Name',
  next: 'Next',
  password: 'Password',
  passwordRequirements: 'Password Requirements',
  register: 'Register',
  resendCode: 'Resend Code',
  select: 'Select',
  signIn: 'Sign In',
  signUp: 'Sign Up',
  submit: 'Submit'
}

const survey: ISurveyDict = {
  surveyTitle: 'We’d love to hear from you.',
  surveyInstructions: '',
  'question-event':
    "What do you want to get out of this event?<br/>Is there something specific you'd like to learn about 5G?"
}

const registration: IRegistrationDict = {
  avatarInstructions: 'Upload picture for event profile',
  city: 'City',
  completeRegistration: `To get started, let's set up your personal profile.`,
  country: 'Country',
  dropImage: 'Drop the image here...',
  emailTooltip:
    'The email entered will receive the login information/link to the live event.<br/>Your email will automatically become your username.',
  emailTooltipPostEvent: 'Your email will automatically become your username.',
  employeeRange1: '0 - 9 Employees',
  employeeRange2: '10 - 499 Employees',
  employeeRange3: '500+ Employees',
  cSuite: 'C-Suite',
  vp: 'VP',
  director: 'Director',
  manager: 'Manager',
  staff: 'Staff',
  joinUs: '5G Innovation Sessions:<br/> Supporting Public Safety on<br/> the frontline',
  joinUsRoot: 'Supporting Public Safety<br/>on the frontline',
  registerToSecureYourSpot:
    'By registering, you are securing your spot for the upcoming event on our virtual platform.',
  mailingAddress: 'Mailing address',
  mailingAddressReason:
    'If you would like to receive a complimentary program package, please provide your mailing address below.',
  companyAddress: 'Organization address',
  companyName: 'Organization Name',
  phoneNumber: 'Phone Number',
  selectedImage: 'Selected image: ',
  state: 'State/Region',
  aboutYourCompany: 'About your organization',
  companySize: 'Organization size',
  titlePosition: 'Job title',
  youreIn: "Congrats, You're In!",
  postalCode: 'Zip code',
  emailWillBecomeUsername: 'Your email will automatically become your username.',
  company: 'Agency/Company',
  review: 'Review the ',
  detailsAndAgenda: 'event details and agenda here.'
}

const breakout: IBreakoutDict = {
  registerForABreakout: 'Register for a<br/> breakout session.',
  reserveYourBreakoutBlurb:
    "Following the presentations, you'll have an opportunity to hear how your business can take advantage of the full, transformative power of 5G.  Let our experts take you on a deeper dive into vertical-specific use cases to demonstrate how your business can benefit from Verizon's 5G.<br /><br /> Each session includes a live Q&A. Capacity is limited to 200 attendees each. Please make your selection to save your spot!",
  breakoutSession: 'Breakout session',
  'breakoutSessionName-healthcareInsurance': 'Healthcare, Insurance & Life Sciences',
  'breakoutSessionPresenter-healthcareInsurance': '',
  'breakoutSessionDescription-healthcareInsurance': '',
  'breakoutSessionName-retailTravelDistribution': 'Retail/Hospitality, Travel & Distribution',
  'breakoutSessionPresenter-retailTravelDistribution': '',
  'breakoutSessionDescription-retailTravelDistribution': '',
  'breakoutSessionName-financialServices': 'Financial Services',
  'breakoutSessionPresenter-financialServices': '',
  'breakoutSessionDescription-financialServices': '',
  'breakoutSessionName-manufacturingEnergyUtilities': 'Manufacturing, Automotive, Construction, Energy & Utilities',
  'breakoutSessionPresenter-manufacturingEnergyUtilities': '',
  'breakoutSessionDescription-manufacturingEnergyUtilities': '',
  'breakoutSessionName-mediaEntertainmentTech': 'Media, Entertainment, Technology & Services',
  'breakoutSessionPresenter-mediaEntertainmentTech': '',
  'breakoutSessionDescription-mediaEntertainmentTech': '',
  finish: 'Finish',
  skip: 'Skip'
}

const passwordRequirements: IPasswordReqDict = {
  passwordMustContain: 'Password must contain:',
  passwordReqLength: 'Must contain at least 12 characters',
  passwordReqUpperCase: 'Must contain at least one upper-case letter',
  passwordReqLowerCase: 'Must contain at least one lower-case letter',
  passwordReqNumber: 'Must contain at least one number',
  passwordReqSymbol: 'Must contain at least one special character'
}

const thankYou: IThankYouDict = {
  lookForwardToSeeingYou: 'We look forward to seeing you!',
  registrationCompleteBlurb:
    'We look forward to seeing you at 5G Innovation Sessions: Supporting Public Safety on the frontline on June 10, 2021 at 2&nbsp;&nbsp;PM EDT.',
  stayTuned:
    'Please check your email for the registration confirmation and be sure to add the event to your calendar: ',
  eventInfo: 'Event info',
  verizonHub: 'Verizon Hub'
}

const errors: IErrorDict = {
  emailAlreadyRegistered: 'This email is already registered, please Sign in.',
  emailNotFound: 'E-mail not found',
  incorrectEmailOrPassword: 'Incorrect E-mail.',
  invalidConfirmationCode: 'Invalid confirmation code.',
  invalidEmail: 'Invalid E-mail Address',
  invalidPassword: 'Password does not meet requirements',
  invalidPhone: 'Invalid Phone Number',
  invalidZip: 'Invalid Postal Code',
  invalidCity: 'Invalid City',
  limitExceeded: 'Attempt limit exceeded. Please try again later.',
  passwordsMustMatch: 'Passwords must match.',
  requiredField: 'Required Field',
  emailNotRegistered: 'This email is not registered, please Sign up.'
}

const scenes: IScenesDict = {
  exploreSceneTitle: 'Experience the power of Verizon 5G Ultra Wideband.',
  exploreSceneBlurb:
    'What can Verizon 5G Ultra Wideband do for you? Explore the various ways our 5G network is moving America forward. ',
  sessionsSceneTitle: 'See what 5G can do for Public Safety agencies and first responders.',
  sessionsSceneBlurb:
    'Explore how we’re using 5G technology to develop new capabilities to answer Public Safety challenges.',
  clickAndDragToExplore: 'Click and drag to explore',
  theEventWillBeginIn: 'The next session will begin in',
  theEventWillStartOn: 'The next session will start on',
  explore: 'Explore',
  sessions: 'Sessions',
  connect: 'Connect',
  liveStream: 'Livestream',
  startingSoon: 'The Live Event is starting soon',
  goToLiveStream: 'Go to Livestream',
  genericBreakoutsStartingMessage:
    'It’s almost time to hear how your business can take advantage of the full, transformative power of Verizon 5G Ultra Wideband. Let our experts to take you on a deeper dive into vertical-specific use cases to demonstrate how Verizon 5G can benefit you. Each session includes a live Q&A. Click below to see which sessions are available to join.'
}

export const en = {
  ...common,
  ...passwordRequirements,
  ...errors,
  ...registration,
  ...breakout,
  ...survey,
  ...thankYou,
  ...scenes
}
